export const toastTypes = {
  success: {
    label: 'Sukses',
    value: 'success'
  },
  error: {
    label: 'Gagal',
    value: 'error'
  },
  warning: {
    label: 'Peringatan',
    value: 'warning'
  }
}

export const defaultToastOptions = () => ({
  showClose: true
})
